<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="预约信息">
        <table cellspacing="0" cellpadding="0" class="ProjectOrderTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">系统编号：</td>
            <td>{{appointmentOrderVO.billNo}}</td>
            <td class="tableLabel">登记人：</td>
            <td>{{appointmentOrderVO.creatorName}}</td>
            <td class="tableLabel">登记日期：</td>
            <td>{{appointmentOrderVO.creatTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">小微产品线：</td>
            <td>{{appointmentOrderVO.productLine}}</td>
            <td class="tableLabel">型号：</td>
            <td>{{appointmentOrderVO.transducerModel}}</td>
            <td class="tableLabel"/>
            <td/>
          </tr>
          <tr>
            <td class="tableLabel">设备名称：</td>
            <td>{{appointmentOrderVO.equipmentName}}</td>
            <td class="tableLabel">(直线)客户名称：</td>
            <td>{{appointmentOrderVO.customerName}}</td>
            <td class="tableLabel">终端客户(现场)：</td>
            <td>{{appointmentOrderVO.siteName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">工作过程总结：</td>
            <td>{{appointmentOrderVO.maintainNote}}</td>
            <td class="tableLabel">技术支持初步判断：</td>
            <td>{{appointmentOrderVO.initDecide}}</td>
            <td class="tableLabel">当前状态：</td>
            <td>{{appointmentOrderVO.isFinish ? '已完成' : '未完成'}}</td>
          </tr>
          <tr>
            <td class="tableLabel">未完成跟进：</td>
            <td>{{appointmentOrderVO.unfinishedNote}}</td>
            <td class="tableLabel">已关闭问题原因分析：</td>
            <td>{{appointmentOrderVO.causeNote}}</td>
            <td class="tableLabel">工作类型：</td>
            <td>{{appointmentOrderVO.workerType}}</td>
          </tr>
          <tr>
            <td class="tableLabel">业务需求：</td>
            <td>{{appointmentOrderVO.businessRequirements}}</td>
            <td class="tableLabel">需协助跟进人员：</td>
            <td>{{appointmentOrderVO.assistant}}</td>
            <td class="tableLabel">销售工程师：</td>
            <td>{{appointmentOrderVO.salesmanName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">服务时长/h：</td>
            <td>{{appointmentOrderVO.serviceTime}}</td>
            <td class="tableLabel">产品二维码扫码：</td>
            <td>{{appointmentOrderVO.machineSerialNo}}</td>
            <td class="tableLabel"/>
            <td/>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="报价处理">
        <table cellspacing="0" cellpadding="0" class="ProjectOrderTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">客户意见：</td>
            <td>
              <el-select v-model="appointmentOrderVO.isCustomerAgree" clearable placeholder="请选择">
                <el-option label="是" :value="true"/>
                <el-option label="否" :value="false"/>
              </el-select>
            </td>
            <td class="tableLabel">不同意原因：</td>
            <td>
              <el-input v-model="appointmentOrderVO.disagreeReasons" placeholder="请输入" type="textarea"/>
            </td>
            <td class="tableLabel">收费订单号：</td>
            <td>
              <el-input v-model="appointmentOrderVO.chargeOrderNo" placeholder="请输入" type="textarea"/>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">是否收费：</td>
            <td>
              <el-select v-model="appointmentOrderVO.isCharge" clearable placeholder="请选择">
                <el-option label="是" :value="true"/>
                <el-option label="否" :value="false"/>
              </el-select>
            </td>
            <td class="tableLabel">要求收费日期：</td>
            <td>
              <el-date-picker
                  v-model="appointmentOrderVO.chargeDate"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  placeholder="选择日期"/>
            </td>
          </tr>
        </table>
        <div>
          <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">报价单信息</div>
          <el-button v-if="updatePriceSheetsAuth" type="primary" style="margin-bottom: 10px" @click="$refs.addPriceSheet.open(-1,null)">
            新建
          </el-button>
          <el-button
              v-if="updatePriceSheetsAuth"
              :loading="saveLoading"
              style="margin-bottom: 5px"
              type="primary"
              @click="savePriceSheets">
            保存
          </el-button>
          <el-table
              ref="payData1"
              :data="appointmentOrderVO.appointmentPriceSheets">
            <el-table-column type="index" align="center" label="行号"/>
            <el-table-column prop="itemName" align="center" label="项目名称"/>
            <el-table-column prop="serviceContent" align="center" label="服务内容"/>
            <el-table-column prop="chargeReason" align="center" label="收费原因"/>
            <el-table-column prop="price" align="center" label="价格"/>
            <el-table-column prop="note" align="center" label="备注"/>
            <el-table-column
                label="操作"
                align="center"
                class-name="vm-table_operate"
                width="120px">
              <template slot-scope="scope">
                <el-button v-if="updatePriceSheetsAuth" type="primary" @click="$refs.addPriceSheet.open(scope.$index,scope.row)">编辑</el-button>
                <el-button v-if="updatePriceSheetsAuth" type="danger" @click="oneDeletePriceSheet(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="收费确认">
        <table cellspacing="0" cellpadding="0" class="ProjectOrderTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">客户意见：</td>
            <td>{{appointmentOrderVO.isCustomerAgree?"是":"否"}}</td>
            <td class="tableLabel">不同意原因：</td>
            <td>{{appointmentOrderVO.disagreeReasons}}</td>
            <td class="tableLabel">收费订单号：</td>
            <td>{{appointmentOrderVO.chargeOrderNo}}</td>
          </tr>
        </table>
        <div>
          <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">申请延期</div>
          <el-table
              ref="yqDate">
            <el-table-column type="index" align="center" label="行号"/>
            <el-table-column prop="itemName" align="center" label="审批人"/>
            <el-table-column prop="serviceContent" align="center" label="申请延期时间"/>
            <el-table-column prop="chargeReason" align="center" label="申请时间"/>
            <el-table-column prop="price" align="center" label="申请人"/>
            <el-table-column prop="note" align="center" label="审批意见"/>
            <el-table-column prop="note" align="center" label="备注"/>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane name="three" label="服务评价">
        <el-rate
            v-model="appointmentOrderVO.serviceScore"
            show-text
            :texts="texts"/>
      </el-tab-pane>
    </el-tabs>

    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">订单附件</div>
      <el-table
          ref="payData1"
          :data="appointmentOrderVO.attachments">
        <el-table-column type="index" align="center" label="行号"/>
        <el-table-column prop="fileName" align="center" label="图片">
          <template slot-scope="scope">
            <el-image
                style="width: 50px; height: 50px;margin-right: 10px"
                :src="scope.row.imgUrl"
                :preview-src-list="imgUrls"/>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" align="center" label="附件描述">
          <template slot-scope="scope">
            <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px;margin: 0 auto;text-align: center"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140" class-name="vm-table_operate">
          <template slot-scope="scope">
            <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">现场照片</div>
      <div>
        <el-image
            v-for="item in appointmentOrderVO.siteAttachments"
            :key="item"
            style="width: 100px; height: 100px;margin-right: 10px"
            :src="item"
            :preview-src-list="srcList"/>
      </div>
    </div>

    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">客户签名</div>
      <div>
        <el-image
            v-for="item in appointmentOrderVO.signatureAttachments"
            :key="item"
            style="width: 100px; height: 100px;border: 1px solid #ccc;border-radius: 5px;margin-right: 10px"
            :src="item"
            :preview-src-list="srcList"/>
      </div>
    </div>
    <add-price-sheet ref="addPriceSheet" @save-success="addPriceSheets"/>
    <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
  </div>
</template>

<script>
  import HandleDetail from "../../workFlow/HandleDetail.vue";
  import AddPriceSheet from "@/views/AfterSaleManage/AppointmentOrder/AddPriceSheet";
  export default {
    name:"AppointmentPreview",
    components:{HandleDetail,AddPriceSheet},
    data() {
      return {
        srcList:[],
        billId:"",
        billType:"15",
        pkid:"",
        saveLoading: false,
        updatePriceSheetsAuth: this.$auth(904),
        imgUrls: [],
        appointmentItemTemplates1: [],
        appointmentItemTemplates2: [],
        appointmentItemTemplates3: [],
        texts: ["非常不满意", "不满意", "基本满意", "满意", "非常满意"],
        appointmentOrderVO: {
          pkid: "",
          billNo: "",
          creatTime: "",
          appointmentTime: "",
          creatorName: "",
          debugName: "",
          customerId: "",
          customerName: "",
          salesmanId: "",
          salesmanName: "",
          salesMobile: "",
          salesOrderNo: "", //出厂编号
          siteName: "",
          contact: "",
          siteMobile: "",
          natureNote: "",
          projectLeader: "",
          serviceAddress: "", //服务地址
          serviceQuantity: "", //服务台数
          submitTime: "", //提交日期
          siteDescription: "", //审核意见
          responsibilityDecide: "", //审核意见
          questionType: "", //审核意见
          mainBoardModel: "",
          transducerModel: "",
          causeNote: "",
          faultNote: "",
          isCharge: "",
          chargeDate: "",
          disagreeReasons: "",
          isCustomerAgree: "",
          chargeOrderNo: "",
          isDeferred: "",
          deferredTime: "",
          arrivalTime: "",
          leaveTime: "",
          maintainNote: "",
          serviceScore: "",
          serviceResult: "",
          responsibilityDepartment: "",
          attachments: [],
          siteAttachment: [],
          signatureAttachments: [],
          delayTableData: [],
          appointmentItems1: [],
          appointmentItems2: [],
          appointmentPriceSheets: [],
        },
      };
    },
    created() {
      this.billId = this.$route.query.billId;
      this.getData();
      this.getTemplateList();
    },
    destroyed() {
      this.billId = "";
      this.appointmentOrderVO={};
    },
    methods:{
      getData() {
        this.$http.get("basic",`appointmentOrders/${this.billId}`).then((res)=>{
          this.appointmentOrderVO = res.data;
          this.appointmentOrderVO.siteAttachments.forEach(row => {
            this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
              if (res.success) {
                row.imgUrl = res.data;
                this.imgUrls.push(row.imgUrl);
              }
            });

          });
          this.appointmentOrderVO.signatureAttachments.forEach(row => {
            this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
              if (res.success) {
                row.imgUrl = res.data;
                this.imgUrls.push(row.imgUrl);
              }
            });

          });
          this.appointmentOrderVO.attachments.forEach(row => {
            this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
              if (res.success) {
                row.imgUrl = res.data;
                this.imgUrls.push(row.imgUrl);
              }
            });

          });
        }).catch(()=>{
        });
      },
      addPriceSheets(row,index) {
        console.log(row,index);
        if (index>=0) {
          this.appointmentOrderVO.appointmentPriceSheets[index] = row;
        }else {
          this.appointmentOrderVO.appointmentPriceSheets.push(row);
        }

      },
      oneDeletePriceSheet(index) {
        this.appointmentOrderVO.appointmentPriceSheets.splice(index, 1);
      },
      savePriceSheets() {
        this.appointmentOrderVO.siteAttachments=[];
        this.appointmentOrderVO.signatureAttachments=[];
        this.saveLoading = true;
        this.$http
          .put("basic", "appointmentOrders/updatePriceSheets",this.appointmentOrderVO)
          .then(() => {
            this.saveLoading = false;
            this.$message.success("保存成功");
          }).catch(() => {
            this.saveLoading = false;
          });
      },
      getTemplateList() {
        this.$http
          .get("basic", "appointmentItemTemplates/getAllList")
          .then(resp => {
            this.appointmentItemTemplates1 = [];
            this.appointmentItemTemplates2 = [];
            resp.data.forEach(item=>{
              if (item.itemType === 10) {
                this.appointmentItemTemplates1.push(item);
              }else if (item.itemType === 20) {
                this.appointmentItemTemplates2.push(item);
              }else {
                this.appointmentItemTemplates3.push(item);
              }
            });
          });
      },
      downLoad(row) {
        console.log(row);
        let url = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
        let a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.download = row.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
    },
  };
</script>

<style lang="scss">
table.ProjectOrderTable {
  font-family: verdana,arial,sans-serif;
  font-size:11px;
  color:#333333;
  border-left: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}
table.ProjectOrderTable th {
  text-align: left;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebeef5;
  background-color: #f4f7fa;
}
table.ProjectOrderTable td {
  padding: 8px;
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}
.tableLabel {
  width: 10%;
  text-align: right;
  background-color: #D1E6F5;
}
</style>
